'use strict';

angular.module('webAgro1App').factory('PeriodosService', function($http) {
  return {
    list: function() {
      return $http.get(`${SERVER }v1/periodos`);
    }
  };
});
